export default __webpack_public_path__ + "static/media/showreel.7ec6694c.mp4";